import { LoggingService } from "./loggingSvc";
import { HttpTrackingConfig } from "../../ShellCommon/logger/http-interceptor";
import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";

/**
 * jarvis service calls to JarvisCM api
 */
export interface JarvisService {
  /**
   * @param email email to search.
   */
  searchByEmail(email: string): any;

  /**
   * @param phone phoneNumber to search.
   */
  searchContactsByPhoneNumber(phone: string): any;

  /**
   * @param id customer id to search.
   */
  searchCustomersById(id: string): any;

  /**
   * @param email email to search
   */
  searchContactsByEmail(email: string): any;
}

export const jarvisStem = "SDController/api/Jarvis/";

/**
 * JarvisService
 */
export class JarvisServiceImplementation implements JarvisService {
  // @ngInject
  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private loggingService: LoggingService,
    private sdConfig: ServiceDeskConfig
  ) {}

  public searchByEmail(email: string): ng.IPromise<any> {
    let config: HttpTrackingConfig = {
      headers: {
        "Content-Type": "application/json"
      },
      dependencyOperationName: "Jarvis.email"
    };
    let endpoint = jarvisStem.concat(`email?email=${email}`);
    return this.$http
      .post(this.sdConfig.sdBaseUrl + endpoint, config)
      .then((success) => {
        return success.data;
      })
      .catch((failure) => {
        let errorMessage = "Request to Jarvis search: " + JSON.stringify(failure);
        this.loggingService.logError(errorMessage);
        return this.$q.reject(errorMessage);
      });
  }

  public searchCustomersById(id: string): ng.IPromise<any> {
    let config: HttpTrackingConfig = {
      headers: {
        "Content-Type": "application/json"
      },
      dependencyOperationName: "Jarvis.customers"
    };
    let endpoint = jarvisStem.concat(`customerById?id=${id}`);
    return this.$http
      .get(this.sdConfig.sdBaseUrl + endpoint, config)
      .then((success) => {
        return success.data;
      })
      .catch((failure) => {
        let errorMessage = "Request to Jarvis customers: " + JSON.stringify(failure);
        this.loggingService.logError(errorMessage);
        return this.$q.reject(errorMessage);
      });
  }

  public searchContactsByEmail(email: string): ng.IPromise<any> {
    let config: HttpTrackingConfig = {
      headers: {
        "Content-Type": "application/json"
      },
      dependencyOperationName: "Jarvis.contacts"
    };
    let endpoint = jarvisStem.concat(`contactsSearchByEmail?email=${email}`);
    return this.$http
      .post(this.sdConfig.sdBaseUrl + endpoint, config)
      .then((success) => {
        return success.data;
      })
      .catch((failure) => {
        let errorMessage = "Request to Jarvis contacts: " + JSON.stringify(failure);
        this.loggingService.logError(errorMessage);
        return this.$q.reject(errorMessage);
      });
  }

  public searchContactsByPhoneNumber(phone: string): ng.IPromise<any> {
    let config: HttpTrackingConfig = {
      headers: {
        "Content-Type": "application/json"
      },
      dependencyOperationName: "Jarvis.phone"
    };
    let endpoint = jarvisStem.concat(`contactsSearchByPhone?phone=${phone}`);
    return this.$http
      .post(this.sdConfig.sdBaseUrl + endpoint, config)
      .then((success) => {
        return success.data;
      })
      .catch((failure) => {
        let errorMessage = "Request to Jarvis search: " + JSON.stringify(failure);
        this.loggingService.logError(errorMessage);
        return this.$q.reject(errorMessage);
      });
  }
}
